/**
 * CODE_COMMENTS_12
 * CODE_COMMENTS_221
 */
import currentUserReducerCreator from './currentUserReducerCreator'

import {
  SAVE_CURRENT_USER,
  UPDATE_PERMISSIONS_OF_CURRENT_USER,
  UPDATE_BASIC_INFO_OF_CURRENT_USER,
  RESET_CURRENT_USER_STATE
} from '../../actions/actionTypes'

import {
  REDUCER_NAMES_CURRENT_USER,
} from '../../../constants'


export default currentUserReducerCreator({
  reducerName: REDUCER_NAMES_CURRENT_USER,
  saveCurrentUserAction: SAVE_CURRENT_USER,
  resetUser: RESET_CURRENT_USER_STATE,
  updateBasicInfoOfCurrentUserAction: UPDATE_BASIC_INFO_OF_CURRENT_USER,
  updatePermissionsOfCurrentUserAction: UPDATE_PERMISSIONS_OF_CURRENT_USER,
})
